/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /customers/{customer-id}/withdrawal
 */
export interface WithdrawalRequestBuilder extends BaseRequestBuilder<WithdrawalRequestBuilder> {
    /**
     * Withdraws a consumer within 14 days of creating each contract: deletes the customer with its locations, contracts, charge points and documents, and mails a confirmation. Refused with a 409 for a business customer, a customer without a contract, a contract past its withdrawal period, or a contract with registered kWh, sales or payouts.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Withdraws a consumer within 14 days of creating each contract: deletes the customer with its locations, contracts, charge points and documents, and mails a confirmation. Refused with a 409 for a business customer, a customer without a contract, a contract past its withdrawal period, or a contract with registered kWh, sales or payouts.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithdrawalRequestBuilderUriTemplate = "{+baseurl}/customers/{customer%2Did}/withdrawal";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithdrawalRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: WithdrawalRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
};
/* tslint:enable */
/* eslint-enable */
